import { Box, Typography } from '@mui/material';

/**
 * 页面标题组件的属性
 */
interface PageHeaderProps {
  /** 页面主标题 */
  title: string;
  /** 页面副标题 */
  subtitle?: string;
  /** 右侧操作区域，通常放置按钮等操作元素 */
  action?: React.ReactNode;
}

/**
 * 页面标题组件
 *
 * 用于页面顶部显示标题和操作按钮。
 *
 * @example
 * // 基本用法
 * <PageHeader title="用户管理" />
 *
 * @example
 * // 带副标题
 * <PageHeader title="用户管理" subtitle="管理系统中的所有用户" />
 *
 * @example
 * // 带操作按钮
 * <PageHeader
 *   title="用户管理"
 *   subtitle="管理系统中的所有用户"
 *   action={<Button variant="contained">添加用户</Button>}
 * />
 */
export function PageHeader({ title, subtitle, action }: PageHeaderProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        mb: 3,
        flexWrap: 'wrap',
        gap: 1,
      }}
    >
      <Box>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
    </Box>
  );
}
